import {
  TABLE_DIVIDER_WIDTH,
  TABLE_PAGINATION_HEIGHT,
} from '@/features/shared/components/tableSystem/tableConstants';
import { resolveTableDividerColor } from '@/features/shared/components/tableSystem/tableDividerSx';
import { Box, Skeleton } from '@/ui/primitives';
import {
  tablePaginationChromeSx,
  tablePaginationFooterContainerSx,
} from '@/ui/primitives/tablePaginationChrome';
import type { BoxProps } from '@/ui/primitives';
import type { ReactElement } from 'react';

const TABLE_SKELETON_FOOTER_WIDTH = '380px';
const TABLE_SKELETON_RADIUS = '999px';
const TABLE_SKELETON_FOOTER_OFFSET_Y = '0px';
const TABLE_SKELETON_FOOTER_RIGHT_GAP = '4px';
const TABLE_SKELETON_FOOTER_HEIGHT = `${TABLE_PAGINATION_HEIGHT}px`;

export const SkeletonPaginationFooter = (): ReactElement => (
  <Box
    sx={
      [
        tablePaginationFooterContainerSx,
        {
          borderTop: (muiTheme) =>
            `${String(TABLE_DIVIDER_WIDTH)}px solid ${resolveTableDividerColor(muiTheme)}`,
          height: TABLE_SKELETON_FOOTER_HEIGHT,
          minHeight: TABLE_SKELETON_FOOTER_HEIGHT,
          maxHeight: TABLE_SKELETON_FOOTER_HEIGHT,
        },
      ] as BoxProps['sx']
    }
  >
    <Box
      sx={
        [{ width: '100%', minWidth: 0, height: '100%' }, tablePaginationChromeSx] as BoxProps['sx']
      }
    >
      <Box className="MuiTablePagination-bar">
        <Box
          className="MuiTablePagination-group"
          sx={{
            mr: TABLE_SKELETON_FOOTER_RIGHT_GAP,
            position: 'relative',
            top: TABLE_SKELETON_FOOTER_OFFSET_Y,
          }}
        >
          <Skeleton
            variant="rounded"
            width={TABLE_SKELETON_FOOTER_WIDTH}
            height="14px"
            sx={{ transform: 'none', borderRadius: TABLE_SKELETON_RADIUS }}
          />
        </Box>
      </Box>
    </Box>
  </Box>
);
